// extracted by css-extract-rspack-plugin
export default {"footnotesList":"OverviewTemplate-module__footnotesList__ZRiIi","footnotesItem":"OverviewTemplate-module__footnotesItem__fNAZe"};